// extracted by mini-css-extract-plugin
export default {"tabList":"TermsPage__tabList___hqsVo","tabItem":"TermsPage__tabItem___NjRQk","document":"TermsPage__document___thRd9","section":"TermsPage__section___RTn6Z"};